import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ez5qjgb84: FaireProductEntity = {
  token: "p_8ez5qjgb84",
  type: "product",
  name: "Tree Quilt Shopping Tote",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/4c8ee0856b235c2bc54ef45c8bfe6cf7cf0489386a464d794e60bab1e43e49f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c9d5222738f7d87041ab1572cff8646e17ef680ece47d24fffdb9fb7c08749c.jpeg",
    "https://cdn.faire.com/fastly/a6bf24f548b76073469f7486313225911d8e0d43ae060042c70da79fc4dbefbd.jpeg"
  ],
  priceDollars: 7,
  description: "A shopping tote from our Christmas Collection featuring a double-sided design displaying a craft inspired Christmas tree quilt design with quilt check pattern on the gussets. Quilt designs are replicated from original art hand painted in a unique watercolor style. Seasonal market tote includes both hand and shoulder straps in red nylon and a convenient inside pocket displaying a tree quilt patch design. Our Tree Quilt shopping tote is made from eco-friendly post-consumer material and folds flat for compact storage. A craft Christmas tote perfect for a seasonal accessory and great for reusable gift wrapping.",
  tags: [],
  msrpDollars: 13.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:38.740Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
